import React from 'react';
import { Field } from 'formik';

import FormField from './FormField';
import FormInputTreeBg from './FormInputTreeBg';

const FormInput = ({
  treeStyle = false,
  lineStyle = false,
  children,
  ...props
}) => (
  <FormField {...props}>
    {({
      invalid, valid, className = '', ...p
    }) => (
      <>
        {treeStyle && <FormInputTreeBg />}
        <Field
          className={`${className}${treeStyle ? ' input-tree' : ''}${lineStyle ? ' input-line' : ''}`}
          {...{ ...p, children }}
        />
      </>
    )}
  </FormField>
);

export default FormInput;
